import { Button, Text } from '@elladx/design-system';
import { Trash2 } from 'lucide-react';
import Modal from './Modal';
interface DeleteAddressModalProps {
    isOpen: boolean;
    deleting: boolean;
    onClose: () => void;
    onConfirm: () => void;
}
function DeleteAddressModal({ isOpen, deleting, onClose, onConfirm }: DeleteAddressModalProps) {
    return (<Modal isOpen={isOpen} onClose={onClose} title="Delete Address" dismissible={!deleting}>
      <Text style={{ marginBottom: '20px' }}>
        Are you sure you want to delete this address? This action cannot be undone.
      </Text>
      <div className="dialog-actions">
        <Button onClick={onClose} disabled={deleting} variant="ghost" type="submit">
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={deleting} variant="danger-secondary" type="submit" isLoading={deleting}>
          <Trash2 size={16}/>
          {deleting ? 'Deleting...' : 'Delete'}
        </Button>
      </div>
    </Modal>);
}
export default DeleteAddressModal;
